import React from "react";
import qs from "qs";

import Entry from "./Entry";
import Security from "./Security";

import { Redirect } from "react-router";

export default {
  entry: Entry,
  enrollSecurity: Security,
  loginComplete: () => {
    const params = qs.parse(window.location.search.substr(1));

    const isContentOnly = params["contentOnly"] === "true";

    return (
      <Redirect
        to={isContentOnly ? "/app/login/enrolled?contentOnly=true" : "/app"}
      />
    );
  },
};



// WEBPACK FOOTER //
// ./src/banking/authentication/Enroll/steps/index.js